import React, { Fragment } from 'react';
import { Box } from '@adsk/alloy-react-box';
const AutomaticAboutBoxContent = _ref => {
  let {
    collections
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, collections === null || collections === void 0 ? void 0 : collections.map(collection => /*#__PURE__*/React.createElement(Fragment, {
    key: collection.type
  }, /*#__PURE__*/React.createElement(Box, {
    margin: "10px 0 4px",
    typography: "heading4",
    marginTop: "20px"
  }, "The following components are licensed under ", collection.type, ' ', "license:"), collection.licenses.map((license, i) => {
    let author;
    if (typeof license.author === 'string') {
      author = license.author;
    } else if (typeof license.author === 'object') {
      author = license.author.name;
    } else {
      author = license.repository;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: license.name + i
    }, /*#__PURE__*/React.createElement(Box, {
      margin: "10px 0 4px",
      typography: "labelMedium"
    }, license.name), /*#__PURE__*/React.createElement(Box, {
      margin: "10px 0 4px",
      typography: "labelSmall",
      marginTop: 0
    }, "Copyright ", author), !collection.attribution && /*#__PURE__*/React.createElement(Box, {
      margin: "10px 0 4px"
    }, license.licenseText));
  }), collection.attribution && /*#__PURE__*/React.createElement(Box, {
    margin: "10px 0 4px"
  }, collection.attribution))));
};
export default AutomaticAboutBoxContent;
//# sourceMappingURL=AutomaticAboutBoxContent.js.map